import {Paper, withWidth, MenuItem, Grid, Select} from '@material-ui/core';
import React from 'react';
import './EnrollmentFileVolumeAndTurnAroundChart.sass';
import {
  FlexibleXYPlot,
  XAxis,
  YAxis,
  VerticalGridLines,
  HorizontalGridLines,
  VerticalBarSeries,
  HorizontalBarSeries,
  LabelSeries,
} from 'react-vis';
import {WithWidthProps} from '@material-ui/core/withWidth';
import {LifeCycleReportChartDetailsPayload} from 'Enrollment/models/LifeCycleReportChartDetailsPayload';
import {ChartType} from './ETSAdminDashboard';

type EnrollmentFileVolumeAndTurnAroundChartProps = {
  lifeCycleReportChartDetails: LifeCycleReportChartDetailsPayload;
  selectedChartType: ChartType;
  handleChartTypeChange: (value: ChartType) => void;
} & WithWidthProps;

const EnrollmentFileVolumeChart = (props: EnrollmentFileVolumeAndTurnAroundChartProps) => {
  const chartTypeDropDown = [ChartType.Weekly, ChartType.Monthly];
  const isMobile = ['sm', 'xs', 'md'].includes(props.width || 'xl');
  const BarSeries: any = isMobile ? HorizontalBarSeries : VerticalBarSeries;
  const {lifeCycleReportChartDetails, selectedChartType, handleChartTypeChange} = props;
  const fileVolumeData =
    lifeCycleReportChartDetails.fileVolumesChart && lifeCycleReportChartDetails.fileVolumesChart.length > 0
      ? lifeCycleReportChartDetails.fileVolumesChart
      : null;

  const convertThousandInK = (labelValue: any) => {
    if (labelValue >= 1000) {
      return (labelValue / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return labelValue;
  };

  const fileVolumeChartData = fileVolumeData?.map(record => ({
    x: isMobile ? record.count : record.displayLabel,
    y: isMobile ? record.displayLabel : record.count,
  }));

  const fileVolumeChartLabelData = fileVolumeData?.map(record => ({
    x: isMobile ? record.count : record.displayLabel,
    y: isMobile ? record.displayLabel : record.count ? record.count + 0.5 : record.count,
    label: convertThousandInK(record.count),
  }));

  const fileVolumeMaxCountValue = getMaxCount(fileVolumeData);
  const fileVolumeMinCountValue = getMinCount(fileVolumeData);

  const fileVolumeChartProps: any = {
    yDomain: [fileVolumeMinCountValue, fileVolumeMaxCountValue],
  };

  const fileVolumeChartMobileProps: any = {
    xDomain: [fileVolumeMinCountValue, fileVolumeMaxCountValue],
  };

  const yAxisValueFileVolume = isMobile ? fileVolumeChartMobileProps : fileVolumeChartProps;

  function getMinCount(data: any) {
    return data.reduce((min: any, p: any) => (p.count < min ? p.count : min), data[0].count);
  }
  function getMaxCount(data: any) {
    return data.reduce((max: any, p: any) => (p.count > max ? p.count : max), data[0].count);
  }

  return (
    <Paper className="enrollments-file-volume-chart">
      <div className="enrollments-file-volume-chart__header">
        <Grid container spacing={2} justify="space-between">
          <Grid item>
            <h3 className="enrollments-file-volume-chart__header-title">File Volume</h3>
          </Grid>
          <Grid item>
            <Select
              className="enrollment-file-rejects-modal__remove-content-Options"
              label="Monthly"
              onChange={e => handleChartTypeChange(e.target.value as ChartType)}
              value={selectedChartType}
            >
              {chartTypeDropDown.map((type, index) => (
                <MenuItem key={index} value={type}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
      </div>
      <div className="enrollments-file-volume-chart__container">
        <FlexibleXYPlot
          height={300}
          stackBy={isMobile ? 'x' : 'y'}
          yType={isMobile ? 'ordinal' : undefined}
          xType={!isMobile ? 'ordinal' : undefined}
          margin={isMobile ? {bottom: 40, top: 40, left: 80, right: 20} : {bottom: 80, top: 20, left: 50, right: 50}}
        >
          <VerticalGridLines />
          <HorizontalGridLines />
          {isMobile ? (
            <XAxis {...yAxisValueFileVolume} tickFormat={(v: number) => convertThousandInK(v)} />
          ) : (
            <XAxis tickLabelAngle={-90} />
          )}
          {isMobile ? <YAxis /> : <YAxis />}
          <BarSeries data={fileVolumeChartData} stack barWidth={0.5} />
          <LabelSeries
            data={fileVolumeChartLabelData}
            labelAnchorX="start"
            labelAnchorY="text-after-edge"
            className="enrollments-file-volume-chart__file-volume-label-series"
          />
        </FlexibleXYPlot>
      </div>
    </Paper>
  );
};

export default withWidth()(EnrollmentFileVolumeChart);
